import React from 'react';
import { CardDivider, ValuesList, ValuesListItem, DateFormat, NumberFormat, Tag } from '@crx-dev/hss-react-components';
import { Supplied } from '../types/EntryTypes/Supplied';

interface DispensedInfoProps {
    item: Supplied;
    columns: number;
}

function SuppliedInfo({ item, columns }: DispensedInfoProps) {
    return (
        <>
            <ValuesList columns={columns}>
                <ValuesListItem label="Type">
                    <Tag color="OscarGreen">Supplied</Tag>
                </ValuesListItem>
                <ValuesListItem label="Supplied Date">
                    <DateFormat date={item.createdDateTime} format="date" />
                </ValuesListItem>
                <ValuesListItem label="Quantity" color="BeakerPink">
                    <NumberFormat value={item.quantity} />
                </ValuesListItem>
                <ValuesListItem label="Total Balance" bold>
                    <NumberFormat value={item.balance} />
                </ValuesListItem>
            </ValuesList>

            <CardDivider />

            <ValuesList columns={columns}>
                <ValuesListItem label="Patient Name">{item.patient.name}</ValuesListItem>
                <ValuesListItem label="Patient Address">{item.patient.address}</ValuesListItem>

                <ValuesListItem label="Prescriber Name">{item.prescriber.name}</ValuesListItem>
                <ValuesListItem label="Prescriber Reference Number">{item.prescriber.referenceNumber}</ValuesListItem>

                {(item.deliveredOrCollected === 'Collected' || item.deliveredOrCollected === 'CollectedByPatient') && (
                    <>
                        <ValuesListItem label="Collected By">{item.collector.name}</ValuesListItem>
                        <ValuesListItem label="Collector Address">{item.collector.address}</ValuesListItem>
                        {item.collector.idRequested != null && (
                            <ValuesListItem label="Id Requested">
                                {item.collector.idRequested ? 'Yes' : 'No'}
                            </ValuesListItem>
                        )}
                        <ValuesListItem label="Id Provided">{item.collector.idChecked ? 'Yes' : 'No'}</ValuesListItem>
                    </>
                )}

                {item.deliveredOrCollected === 'Delivered' && (
                    <ValuesListItem label="Delivered By">{item.deliveredBy}</ValuesListItem>
                )}

                <ValuesListItem label="Booked In By">{item.checkedBy}</ValuesListItem>
                <ValuesListItem label="Added By">{item.entryMadeBy}</ValuesListItem>
            </ValuesList>
        </>
    );
}

export default SuppliedInfo;
